<script>
    import IconPage from "./icons/IconPage.svelte";
    export let url, classname
</script>
{#if url !== 'https://guides.pcc.edu'}
        <div class="alert bg-gradient-darkcyan text-white h5 mb-4"
             aria-live="polite"
             aria-atomic="true"
             style="background-color: var(--color-yellow);
             display: flex;
             justify-content: start;
             align-items: center;
             flex-wrap: nowrap;
             padding: var(--form-padding) var(--padding);"
        >
        <IconPage width="1.4rem" height="1.4rem" padding=".5em" fill="#ffffff"/>
                <a href={url} target="_blank">{@html classname} Research Guide</a>
        </div>
{/if}